import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { Navbar } from './components/Navbar';
import { Footer } from './components/Footer';
import { HomePage } from './pages/HomePage';
import { SolutionsPage } from './pages/SolutionsPage';
import { SmartFloorPage } from './pages/SmartFloorPage';
import { SmartPanelPage } from './pages/SmartPanelPage';
import { SmartDoorPage } from './pages/SmartDoorPage';
import { SmartStripsPage } from './pages/SmartStripsPage';
import { SmartSofaPage } from './pages/SmartSofaPage';
import { SmartMachineryPage } from './pages/SmartMachineryPage';
import { SmartGardenPage } from './pages/SmartGardenPage';
import { CatalogPage } from './pages/CatalogPage';
import { DownloadsPage } from './pages/DownloadsPage';
import { AboutPage } from './pages/AboutPage';
import { LegalNoticePage } from './pages/LegalNoticePage';
import { PrivacyPolicyPage } from './pages/PrivacyPolicyPage';
import { CookiePolicyPage } from './pages/CookiePolicyPage';
import { TermsOfUsePage } from './pages/TermsOfUsePage';
import { LanguageProvider } from './i18n/LanguageContext';
function ScrollToTop() {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}
function Layout({
  children
}: {
  children: React.ReactNode;
}) {
  return <div className="flex flex-col min-h-screen font-sans" data-id="element-0">
      <Navbar data-id="element-1" />
      <main className="flex-grow" data-id="element-2">{children}</main>
      <Footer data-id="element-3" />
    </div>;
}
export function App() {
  return <LanguageProvider data-id="element-4">
      <Router data-id="element-5">
        <ScrollToTop data-id="element-6" />
        <Layout data-id="element-7">
          <Routes data-id="element-8">
            <Route path="/" element={<HomePage data-id="element-10" />} data-id="element-9" />
            <Route path="/soluciones" element={<SolutionsPage data-id="element-12" />} data-id="element-11" />
            <Route path="/soluciones/smartfloor" element={<SmartFloorPage data-id="element-14" />} data-id="element-13" />
            <Route path="/soluciones/smartpanel" element={<SmartPanelPage data-id="element-16" />} data-id="element-15" />
            <Route path="/soluciones/smartdoor" element={<SmartDoorPage data-id="element-18" />} data-id="element-17" />
            <Route path="/soluciones/smartstrips" element={<SmartStripsPage data-id="element-20" />} data-id="element-19" />
            <Route path="/soluciones/smartsofa" element={<SmartSofaPage data-id="element-22" />} data-id="element-21" />
            <Route path="/soluciones/smartmachinery" element={<SmartMachineryPage data-id="element-24" />} data-id="element-23" />
            <Route path="/soluciones/smartgarden" element={<SmartGardenPage data-id="element-26" />} data-id="element-25" />
            <Route path="/catalogo" element={<CatalogPage data-id="element-28" />} data-id="element-27" />
            <Route path="/descargables" element={<DownloadsPage data-id="element-30" />} data-id="element-29" />
            <Route path="/empresa" element={<AboutPage data-id="element-32" />} data-id="element-31" />
            <Route path="/aviso-legal" element={<LegalNoticePage data-id="element-34" />} data-id="element-33" />
            <Route path="/privacidad" element={<PrivacyPolicyPage data-id="element-36" />} data-id="element-35" />
            <Route path="/cookies" element={<CookiePolicyPage data-id="element-38" />} data-id="element-37" />
            <Route path="/terminos" element={<TermsOfUsePage data-id="element-40" />} data-id="element-39" />
          </Routes>
        </Layout>
      </Router>
    </LanguageProvider>;
}